import React, { useCallback, useContext } from 'react';
import { CardView } from 'design-system/CardView';
import Section from 'design-system/Section';
import Links from 'utils/links';
import { WalkthroughContext } from 'features/feed/components/walkthrough/context';
import TransactionHelpItem from './TransactionHelpItem';
import { styles } from './styles';
const TransactionPendingSection = () => {
    const isInWalkthrough = useContext(WalkthroughContext);
    const openHelp = useCallback(() => {
        Links.openKnownLink('pendingTxnHelp');
    }, []);
    return (<Section title="Help" titleContainerStyle={!!isInWalkthrough && styles.walkthroughTitleContainer} style={[styles.section, isInWalkthrough && styles.walkthroughSection]}>
      <CardView noMarginTop noMargin={isInWalkthrough}>
        <TransactionHelpItem onPress={openHelp} subTitle="Learn more in our help center" title="Want to know more about pending?"/>
      </CardView>
    </Section>);
};
export default TransactionPendingSection;
